module.exports = __webpack_public_path__ + "static/img/14001008.afb68e54.png";